import {
  Breakpoint,
  styled,
} from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import Markdown, { Justification } from "../coreui/Markdown";
import PaneRow, { WidgetValue } from "../models/PaneRow";
import { AccessLevel } from "./AccessLevel";

interface ConfigProperties {
  dataId: string;
  justification: { [key in Breakpoint]: Justification }
  name: string;
}

interface RuntimeProperties {
  accessLevel: AccessLevel;
  textValue: string;
}

// The cast to `React.ElementType` is required for the component prop to be
// recognized. See https://github.com/mui/material-ui/issues/15695
const MaxWidthDiv = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    maxWidth: "600px",
  },
  [theme.breakpoints.up("lg")]: {
    maxWidth: "580px",
  },
})) as React.ElementType;

export const MarkdownDisplay = observer(
  (props: ConfigProperties): JSX.Element | null => {
    const row = PaneRow.get(props.dataId);
    if (row === null) {
      return null;
    }

    const widget = row.getWidgetT<WidgetValue, RuntimeProperties>(props.name);
    const runtimeProperties = widget.properties;

    if (
      !runtimeProperties ||
      runtimeProperties.accessLevel === AccessLevel.hidden
    ) {
      return null;
    }

    return (
      <MaxWidthDiv>
        <Markdown
          justification={props.justification}
          value={runtimeProperties.textValue}
        />
      </MaxWidthDiv>
    );
  }
);
